export default __webpack_public_path__ + "images/eda487f5d0bba45f78ab7849ef6adcb7.png";